import styled from 'styled-components'
import {colors} from '../../../../styles/theme'

export const StatsBox = styled.div`
  display: flex;
  flex-flow: column;
  gap: 24px;
`

export const StatsItem = styled.div`
  display: flex;
  flex-flow: column;
  gap: 8px;
`
export const StatsTitle = styled.p`
  margin: 0;
  padding: 0;
  display: flex;
  gap: 8px;
  font-size: 16px;
  color: ${colors.bksGray80};
  align-items: center;

  img {
    width: 18px;
    height: 18px;
  }
`

export const StatsPercentage = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

export const ScoreText = styled.span`
  color: ${colors.bksGray70};
  font-size: 14px;
  width: 150px;
`

export const ProgressBox = styled.div`
  width: 100%;
  && .MuiLinearProgress-root {
    width: 100%;
    height: 6px;
    border-radius: 6px;
    margin-right: 10px;
    background-color: #f5f5f5;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);

    span {
      background-color: ${colors.blue1};
    }
  }
`

export const PercentageText = styled.span`
  color: ${colors.blue1};
  font-size: 12px;
  width: 50px;
  text-align: right;
`
